import React from 'react';
import './DropdownMenu.css';
import MenuItem from './MenuItem';
import { IconName } from '../icons/Icon';

interface MenuItemConfig {
  type?: 'Default' | 'Destructive';
  label: string;
  leftIcon?: IconName;
  rightIcon?: IconName;
  showLeftIcon?: boolean;
  showRightIcon?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

interface DropdownMenuProps {
  items: MenuItemConfig[];
  isVisible?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  items,
  isVisible = true,
  className = '',
  style = {}
}) => {
  if (!isVisible) return null;

  return (
    <div
      className={`dropdown-menu ${className}`}
      style={{
        backgroundColor: 'rgba(255,255,255,0.92)',
        boxShadow: '0px 0px 8px 0px rgba(37,41,47,0.08), 0px 4px 4px 0px rgba(37,41,47,0.08)',
        ...style
      }}
    >
      {items.map((item, index) => (
        <MenuItem
          key={index}
          type={item.type || 'Default'}
          state={item.disabled ? 'Disabled' : 'Default'}
          label={item.label}
          leftIcon={item.leftIcon}
          rightIcon={item.rightIcon}
          showLeftIcon={item.showLeftIcon}
          showRightIcon={item.showRightIcon}
          onClick={item.onClick}
          className="w-full"
        />
      ))}
    </div>
  );
};

export default DropdownMenu;